import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Resource as ImportedResource } from '../../types/resourceTypes';

export interface ResourcesState {
  resources: ImportedResource[];
}

const initialState: ResourcesState = {
  resources: [],
};

const resourcesSlice = createSlice({
  name: 'resources',
  initialState,
  reducers: {
    setResources: (state, action: PayloadAction<ImportedResource[]>) => {
      state.resources = action.payload;
    },
    addResource: (state, action: PayloadAction<ImportedResource>) => {
      state.resources.push(action.payload);
    },
  },
});

export type { ImportedResource as Resource };

export const { setResources, addResource } = resourcesSlice.actions;
export default resourcesSlice.reducer;